import React from 'react';
import { bool, string } from 'prop-types';
import {
  IconAirplane,
  IconBusiness,
  IconCard,
  IconCardBenefit,
  IconConcierge,
  IconDining,
  IconDollar,
  IconEntertainment,
  IconHotel,
  IconLounge,
  IconMerchandise,
  IconNeutral,
  IconRewards,
  IconTravelBag,
} from '@americanexpress/dls-icons';
import styles from './AxpBenefitsActivity.scss';

const IconComponent = ({
  icon,
  iconColor,
  isMetaContent = false,
  hideBackground = false,
  isFilled = false,
}) => {
  const iconMapping = {
    IconAirplane,
    IconBusiness,
    IconCard,
    IconCardBenefit,
    IconConcierge,
    IconDining,
    IconDollar,
    IconEntertainment,
    IconHotel,
    IconLounge,
    IconMerchandise,
    IconNeutral,
    IconRewards,
    IconTravelBag,
  };
  const IconImage = iconMapping[icon];
  const shouldRenderIcon = typeof IconImage === 'function';
  const color = iconColor || (isMetaContent ? 'white' : 'brand');

  return shouldRenderIcon && (
    <section data-testid={`icon-section-${icon}`} className={isMetaContent ? 'flex pad-1-r' : 'pad-1-l'}>
      <span>
        <div data-testid={`icon-wrapper-${icon}`} className={!isMetaContent && !hideBackground && styles.iconCircularBackgroundBorder}>
          <IconImage
            size={isMetaContent ? 'sm' : 'md'}
            color={color}
            titleId={`icon-${icon}`}
            data-testid={`icon-${icon}`}
            isFilled={isFilled}
            className={isMetaContent ? 'color-graphic-brand-logo-blue-box-text' : styles.iconCircularBackground}
          />
        </div>
      </span>
    </section>
  );
};

IconComponent.propTypes = {
  icon: string.isRequired,
  iconColor: string,
  isMetaContent: bool,
  hideBackground: bool,
  isFilled: bool,
};

export default IconComponent;
